import './style.css';
import 'flowbite/dist/flowbite.js';
import './sidebar';
import './charts';
import './dark-mode';
import './custom-select';
import './part-menu';
import { mountIfExists } from './vue/mounts';
import AppLabelPrintSelect from './vue/AppLabelPrintSelect.vue';
import AppLabelPrintDetail from './vue/AppLabelPrintDetail.vue';
import AppPackagingPrint from './vue/AppPackagingPrint.vue';
import AppSerialLabelPrint from './vue/AppSerialLabelPrint.vue';
import AppStockQty from './vue/AppStockQty.vue';
import AppIotUsage from './vue/AppIotUsage.vue';

// Progressive Vue mount: only if element exists
function boot() {
  mountIfExists('#vue-label-print-select', AppLabelPrintSelect);
  mountIfExists('#vue-label-print-detail', AppLabelPrintDetail);
  mountIfExists('#vue-packaging-print', AppPackagingPrint);
  mountIfExists('#vue-serial-label-print', AppSerialLabelPrint);
  mountIfExists('#vue-stock-qty', AppStockQty);
  mountIfExists('#vue-iot-usage', AppIotUsage);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}